import * as React from "react"
import trans from "trans"
import Mergado from "app/helpers/mergado"

import {
    DataCell,
    Theme,
    Grid,
    GridCell,
    Icon,
    Select,
} from "@bdfx/mergado-ui-kit"

import {isGodModeOn, isLocalhost, projectId} from "app/helpers/api";

import {
    availableQualityOptionsMistakeByUser,
    renderItemId,
    renderName, SetByUser,
} from "./product-table";
import {URL} from "app/config/api-config";
import {DarkGrayColor} from "app/helpers/colors";
import {StyledDataRow} from "./product-table-table";
import {ExtendedProductType} from "../types";
import { allowSuperadminForUsers } from "template-edit/components/helper";

interface Props {
    image: ExtendedProductType
    getEmptyFiltersForm: Function
    showModal: Function
    idx: number
    changeSetByUser: Function
    userId: number
}

const MERGADO_APP = `https://app.mergado.com/projects/${projectId}/product`

class ImageQualityRow extends React.Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    render() {
        const { image, idx, userId } = this.props

        const icon = (status) => {
            switch (status) {
                case 'OK':
                    return <Icon type={'check'} color={Theme.green} text={trans('status_OK')} />
                case 'ERROR':
                    return <Icon type={'exclamation'} color={Theme.red} text={trans('status_'+image.quality_status)} />
                case 'N/A':
                    return <Icon type={'question'} color={DarkGrayColor} text={trans('status_'+image.quality_status)} />
                case 'NOT_OK':
                    return <Icon type={'close-light'} color={Theme.red} text={trans('status_NOT_OK')} />
                default:
                    return <Icon type={'close-light'} color={DarkGrayColor} text={trans('status_'+image.quality_status)} />
            }
        }

        const addStatusClass = (image.quality_status === 'OK') ? 'ok' : (image.quality_status === 'ERROR' ? 'error' : (image.quality_status === 'NOT_OK' ? 'not-ok' : ''))

        const mergadoProductUrl = `${MERGADO_APP}/${image.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${image.template_id}&product_id=${image.product_id}&nocache=1`


        return <StyledDataRow key={`${image.image_id}`} dataId={`quality-${image.product_id}`} >
            {(isGodModeOn || isLocalhost) &&
            <DataCell key={'image_id'}>{image.image_id}</DataCell>
            }

            <DataCell key={'product_image'} className={'clickable'} onClick={() => this.props.showModal(idx)}>
                <img src={image.image_link} height={50} />
            </DataCell>

            <DataCell key={'product_name'} className='clickable left'>
                {renderName(image.elements_name)}
                <br/>
                {renderItemId(image.elements_item_id)}
            </DataCell>

            <DataCell key={'status'} className={image.quality_user_set ? '' : 'status ' + addStatusClass}>
                {image.quality_user_set !== null ?
                    <span>({trans('set_by_user')})</span> : icon(image.quality_status)
                }

                {image.quality_status !== null &&
                    <Select
                        value={image.quality_user_set !== null ? `${image.quality_user_set}` : null}
                        options={availableQualityOptionsMistakeByUser}
                        onChange={(value) => this.props.changeSetByUser(image.image_id, idx, (value !== '100' ? parseInt(value) : null))}
                    />
                }
            </DataCell>

            {userId && (allowSuperadminForUsers.includes(userId)) &&
            <DataCell key={'status_reason'}>{trans(image.quality_status_reason)}</DataCell>
            }

            <DataCell key={'score'}>{image.quality_score && image.quality_score}</DataCell>

            <DataCell key={'links'} className='centered clickable'>
                <Grid cols={`repeat(5, 1fr)`} className={'product-links'}>
                    {image.image_link &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(image.image_link)}>
                        <Icon type={'file-image-o'} color={Theme.blue} title={trans("link_image_url")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {previewUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(previewUrl)}>
                        <Icon type={'feedimageeditor'} title={trans("link_fie")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {mergadoProductUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(mergadoProductUrl)}>
                        <Icon type={'mergado'} title={trans("link_mergado")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {image.elements_url &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(image.elements_url)}>
                        <Icon type={'shopping-basket'} color={DarkGrayColor} title={trans("link_eshop")} size={20} />
                        </div>
                    </GridCell>
                    }
                </Grid>
            </DataCell>
        </StyledDataRow>
    }
}

export default ImageQualityRow